import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const Base = () => import('@app/Seller/Components/Base')
const PaymentList = () => import('@app/Seller/Payments/List.vue')

const MODEL = 'payment-gateway'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const LIST = ''

export const PAYMENT_PREFIX = `${MODEL}:`
const p = name => PAYMENT_PREFIX + name

export const PAYMENT_BASE_NAME = p('base')
export const PAYMENT_LIST_NAME = p('list')

export function createRoutes(options) {
  return [
    route(BASE, Base, PAYMENT_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: PAYMENT_LIST_NAME },
      children: [
        route(LIST, PaymentList, PAYMENT_LIST_NAME, {
          meta: accessPermission(ALL, options),
        }),
      ],
    }),
  ]
}
